
import { DisablableOption, ModelBase } from "@models";
import { APIClass } from "@utilities/smart_api_class";

export interface Sense extends ModelBase {
  data_type: "sense";
  _id: string;
  name: string;
  description: string;

  // toDBObj(): any {
  //   const base_db_obj = super.toDBObj();
  //   return {
  //     ...base_db_obj,
  //   };
  // }

  // copy(copyMe: Sense, drop_ids: boolean = false): void {
  //   super.copy(copyMe, drop_ids);
  // }

  // clone(drop_ids: boolean = false): Sense {
  //   const new_obj = new Sense();
  //   new_obj.copy(this, drop_ids);
  //   return new_obj;
  // }
}

export const SENSES: Sense[] = [
{
  data_type: "sense",
  _id: "604c3dcfa62f55050cc821aa",
  name: "Darkvision",
  description: "You can see in the dark within range, though you are unable to make out colors.",
  image_url: "",
  archived: false, linkifiedName: "", linkURL: "",
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Darkvision",
  tag_string: "", free: false
}, {
  data_type: "sense",
  _id: "604c5066a62f55050cc821ab",
  name: "Blind Sight",
  description: "You're able to rely on other senses besides sight to identify the locations of things within range.  (This counters advantage/disadvantage for darkness and invisibility).",
  image_url: "",
  archived: false, linkifiedName: "", linkURL: "",
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Blind Sight",
  tag_string: "", free: false
}, {
  data_type: "sense",
  _id: "604c5070a62f55050cc821ac",
  name: "True Sight",
  description: "You can see perfectly regardless of light and darkness, including magical darkness.  You can also see the true form of any shapechanger or creature concealed by illusion or transmutation magic while the creature is within range and line of sight.",
  image_url: "",
  archived: false, linkifiedName: "", linkURL: "",
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "True Sight",
  tag_string: "", free: false
}, {
  data_type: "sense",
  _id: "604c507fa62f55050cc821ad",
  name: "Devil's Sight",
  description: "You have darkvision, and can also see through magical darkness.",
  image_url: "",
  archived: false, linkifiedName: "", linkURL: "",
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Devil's Sight",
  tag_string: "", free: false
}, {
  data_type: "sense",
  _id: "60abc333f0486001f451bd0f",
  name: "Witch Sight",
  description: "You can see the true form of any shapechanger or creature concealed by illusion or transmutation magic while it is within range and line of sight.",
  image_url: "",
  archived: false, linkifiedName: "", linkURL: "",
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Witch Sight",
  tag_string: "", free: false
}, {
  data_type: "sense",
  _id: "67b8a0589f2766e5d3a76461",
  name: "Tremorsense",
  description: "You're able to feel vibrations in the ground, allowing you to know the location of any object or creature that moves while in or touching the ground within range of you, so long as you are in contact with the ground and are not incapacitated. This does work through walls and can be used to ignore invisibility, but there can be materials which block it. It's also a very rare ability and is generally quite limited on its range.",
  image_url: "",
  archived: false, linkifiedName: "", linkURL: "",
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Tremorsense",
  tag_string: "", free: false
}]

export const SENSE_OPTIONS = SENSES.map(at => {
  const opt: DisablableOption = {
    id: at._id,
    text: at.name
  }
  return opt;
});